<template>
  <div class="report">
    <div class="top">
      <div class="main-title"><span>碳排放计算器</span></div>
    </div>
    <div class="main-body">
      <div class="sub-title-img"><span>碳排放报告</span></div>
      <div>
        <p class="body-title">排放概览</p>
        <div class="emission-top-view">
          <div class="digit-view">
            <p class="digit-title">碳排放总量
              <img src="../assets/images/tip.png" @click="showTotalTip" height="10">
            </p>
            <van-popup v-model="isShowTotalTip" round style="height: 25%;width: 80%">
              <p class="emission-level-tip" style="font-weight: bold">碳排放总量计算依据</p>
              <p class="emission-level-tip">根据《xx企业核算办法，将化石燃料、工业生产过程、外购电热等环节碳排放加总得到碳排放总量</p>
            </van-popup>
            <p class="total-emission">{{ totalCarbonEmission }}</p>
            <p class="unit">万吨CO2</p>
          </div>
          <div class="digit-view">
            <p class="digit-title">产值碳排放强度
              <img src="../assets/images/tip.png" @click="showIntensityTip" height="10" style="margin-left: -3px">
            </p>
            <van-popup v-model="isShowIntensityTip" round style="height: 20%;width: 80%">
              <p class="emission-level-tip" style="font-weight: bold">碳排放强度计算依据</p>
              <p class="emission-level-tip">根据碳排放总量和总产值，得到单位产值碳排放强度</p>
            </van-popup>
            <p class="total-emission">{{ totalCarbonIntensity }}</p>
            <p class="unit">万吨CO2</p>
          </div>
          <div class="digit-view">
            <p class="digit-title">碳排放水平
              <img src="../assets/images/tip.png" @click="showTip" height="10">
            </p>
            <van-popup v-model="isShowTip" round style="height: 32%;width: 80%">
              <p class="emission-level-tip" style="font-weight: bold">碳排放水平计算依据</p>
              <p class="emission-level-tip">根据国家统计局发布的最新年度《统计年鉴》中分行业规上工业企业能源消耗数据（折算二氧化碳）得到行业碳排放总量。根据分行业的规上工业企业产值数据，计算得到年度单位产值碳排放强度行业均值。</p>
            </van-popup>
            <p class="emission-level">{{ emissionLevel }}%</p>
            <p class="unit">(对标:行业平均值)</p>
          </div>
        </div>
        <div class="emission-bottom-view">
          <p class="emission-bottom-title">相当于</p>
          <div class="emission-bottom-body">
            <div class="emission-bottom-item">
              <img src="../assets/images/standard_coal.png">
              <div>
                <p class="digit-title">标煤</p>
                <p class="convert-result">{{ standardCoal }}<span class="unit">万吨</span></p>
              </div>
            </div>
            <div class="emission-bottom-item">
              <img src="../assets/images/diesel_oil.png">
              <div>
                <p class="digit-title">柴油</p>
                <p class="convert-result">{{ dieselOil }}<span class="unit">万吨</span></p>
              </div>
            </div>
          </div>
        </div>
        <p class="body-title">排放源结构</p>
        <div class="chart">
          <div id="chartPie" class="pie-wrap"></div>
        </div>
        <p class="body-title">排放源结构</p>
        <div class="popup-group">
          <van-cell title="类型：" :value="from.type" :is-link="isLinkType" @click="showType" class="popup-style"/>
          <van-popup v-model="isShowType" position="bottom" :style="{ height: '30%' }">
            <van-area title="类型" :area-list="typeList" @confirm="confirmType" @cancel="cancel" columns-num="1"/>
          </van-popup>
        </div>
        <!-- 为 ECharts 准备一个定义了宽高的 DOM -->
        <div id="chartBar" style="width: 100%;height:auto;"></div>
        <p class="xAxis-name">排放量(万吨co2)</p>
      </div>
      <div class="btn-block">
        <button class="btn-last" @click="last">重新开始</button>
        <button class="btn-share" @click="share">分享</button>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { mapState } from 'vuex'

require('echarts/theme/macarons')
export default {
  name: 'Report',
  data () {
    return {
      totalCarbonEmission: 0,
      totalCarbonIntensity: 0,
      standardCoal: 0,
      dieselOil: 0,
      emissionLevel: 0,
      // 八大行业碳排放水平的计算参数
      referenceVal: [3.58, 8.50, 0.09, 1.32, 1.27, 1.30, 1.85, 0.92],
      myChart: null,
      pieChartData: [],
      pieChartLegend: [],
      barStateNo: 5,
      barChartYAxis: [],
      barChartData: [],
      typeList: {
        province_list: {}
      },
      isShowType: false,
      isLinkType: true,
      isShowTotalTip: false,
      isShowIntensityTip: false,
      isShowTip: false,
      from: {
        type: '请选择'
      }
    }
  },
  methods: {
    last () {
      this.$router.go(-1)
    },
    share () {
    },
    showType () {
      this.isShowType = true
    },
    cancel () {
      this.isShowType = false
    },
    confirmType (val) {
      this.from.type = ''
      val.forEach((element) => {
        if (this.from.type.indexOf(element.name) === -1) {
          this.from.type = this.from.type + element.name
          this.barStateNo = (element.code - 100) / 10
          console.log(this.barStateNo)
        }
      })
      // 选泽地区后把弹出框和箭头取消
      this.isShowType = false
      this.isLinkType = false
    },
    showTotalTip () {
      this.isShowTotalTip = true
    },
    showIntensityTip () {
      this.isShowIntensityTip = true
    },
    showTip () {
      this.isShowTip = true
    },
    draBarChart () {
      if (this.myChart != null && this.myChart !== '' && this.myChart !== undefined) {
        this.myChart.dispose()
      }
      this.chartBar = echarts.init(document.getElementById('chartBar'), null, {
        width: 400,
        height: 350
      })
      // 指定图表的配置项和数据
      const option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: { // 设置提示框的对齐方式
            align: 'left'
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: '3%',
          right: '3%',
          top: 12,
          bottom: '0',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: false,
          splitLine: { // 去除背景网格线
            show: false
          },
          axisLabel: {
            interval: 0 // 横轴信息全部显示
          },
          axisTick: { // 刻度
            show: false // 不显示刻度线
          }
        },
        yAxis: {
          name: '排放源',
          nameTextStyle: {
            color: '#999999',
            fontSize: 11
          },
          nameGap: 0,
          type: 'category',
          data: this.barChartYAxis,
          axisTick: { // 刻度
            show: false // 不显示刻度线
          },
          axisLine: { // 设置轴线
            show: false
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'MicrosoftYaHei',
              fontSize: '12',
              color: '#333333'
            }
          }
        },
        series: [
          {
            name: '碳排放量',
            type: 'bar',
            data: this.barChartData,
            barWidth: 12,
            itemStyle: { // 柱状图的背景色
              normal: {
                barBorderRadius: 40,
                color: '#2161ff'
              },
              emphasis: {
                barBorderRadius: 40
              }
            }
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      this.chartBar.setOption(option)
    },
    drawPieChart () {
      const myTextStyle = {
        color: '#303030',
        fontSize: 14
      }
      const myLabel = {
        show: true,
        offset: [30, 40],
        textStyle: myTextStyle
      }
      this.chartPie = echarts.init(document.getElementById('chartPie'))
      const orient = 'horizontal'
      this.chartPie.setOption({
        title: {
          x: 'left',
          y: 'top',
          // 主标题文本样式设置
          textStyle: {
            fontSize: 15,
            fontWeight: 'bolder',
            color: '#333333'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} 万吨 ({d}%)'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '碳排放总量\n' + '\n' + this.$data.totalCarbonEmission + '\n' + '\n' + '万吨CO2', // 使用“+”可以使每行文字居中
            textAlign: 'center',
            font: '13px PingFangSC-Regular',
            fill: '#333333',
            width: 30,
            height: 30
          }
        },
        legend: {
          data: this.pieChartLegend,
          x: 'center',
          y: 'bottom',
          orient: orient
        },
        series: [
          {
            name: '碳排放量',
            type: 'pie',
            radius: ['45%', '55%'],
            data: this.pieChartData,
            animationEasing: 'cubicInOut',
            animationDuration: 2600,
            label: {
              emphasis: {
                myLabel,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
      window.onresize = this.chartPie.resize
    }
  },
  computed: {
    ...mapState({
      resList: (state) => state.home.resList,
      annualProValue: (state) => state.home.annualProValue,
      barChartList: (state) => state.home.barChartList,
      bigIndustryNo: (state) => state.home.bigIndustryNo
    })
  },
  watch: {
    barStateNo: function (newVal) {
      let barChartYAxis = [] // 柱状图的纵坐标数据
      let barChartData = [] // 柱状图的数据
      for (let i = 0; i < this.barChartList[newVal].length; i++) {
        barChartYAxis.push(this.barChartList[newVal][i].label)
        barChartData.push(this.barChartList[newVal][i].value.toFixed(3))
      }
      this.barChartYAxis = barChartYAxis
      this.barChartData = barChartData
      this.draBarChart()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.drawPieChart()
      this.draBarChart()
    })
    console.log(this.bigIndustryNo)
    let totalEmission = 0 // 碳排放总量
    let legend = [] // 环形图的图例
    for (let i = 0; i < this.resList.length; i++) {
      totalEmission += this.resList[i].value
      // 通过resList获取饼形图的图例名称
      // resList的值为对象数组，对象的属性有 value：单个输入参数对应的碳排放量；name：饼形图的图例名称
      legend.push(this.resList[i].name)
      // 给柱状图的选择类型的List添加数据
      this.$data.typeList.province_list[100 + i * 10] = this.resList[i].name
    }
    // 相当于多少标煤
    this.$data.standardCoal = (totalEmission / 2.493).toFixed(3)
    // 相当于多少柴油
    this.$data.dieselOil = (totalEmission / 3.163).toFixed(3)
    // 碳排放强度
    this.$data.totalCarbonIntensity = (totalEmission / this.annualProValue).toFixed(3)
    // 碳排放水平
    this.$data.emissionLevel = (((totalEmission / this.annualProValue) / this.$data.referenceVal[this.bigIndustryNo]) * 100).toFixed(2)
    // 碳排放总量
    this.$data.totalCarbonEmission = totalEmission.toFixed(3)
    // 环形图数据
    this.$data.pieChartData = this.resList
    // 环形图图例名称
    this.$data.pieChartLegend = legend
    // 柱状图初始化
    let barChartYAxis = [] // 柱状图的纵坐标数据
    let barChartData = [] // 柱状图的数据
    for (let i = 0; i < this.barChartList[0].length; i++) {
      barChartYAxis.push(this.barChartList[0][i].label)
      barChartData.push(this.barChartList[0][i].value.toFixed(3))
    }
    this.$data.barChartYAxis = barChartYAxis
    this.$data.barChartData = barChartData
  }
}
</script>
<style lang="scss" scoped>
.report {
  width: 100%;
  background-image: url("../assets/images/report_bg.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

.unit {
  font-size: 11px;
  line-height: 6px;
  color: #999999;
}

.digit-title {
  font-weight: bold;
  font-size: 13px;
  color: #333333;
}

.pie-wrap {
  width: 100%;
  height: 400px;
}

.xAxis-name {
  font-size: 11px;
  color: #999999;
  text-align: right;
}

.popup-style {
  border-radius: 10px 10px 0px 0px;
}

.popup-group {
  margin: 15px 200px 15px 15px;
  border-radius: 10px;
}

.emission-level-tip{
  font-size: 18px;
  margin: 20px;
  line-height: 30px;
}

.main-body {
  .sub-title-img {
    width: 116px;
    height: 30px;
    line-height: 30px;
    background-image: url("../assets/images/report_title_bg.png");
    margin-top: 164px;
    margin-bottom: 15px;

    span {
      margin-left: 15px;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .emission-top-view {
    display: flex;
    justify-content: center;

    .digit-view {
      width: 103px;
      height: 103px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(13, 111, 200, 0.26);
      border-radius: 10px 0px 15px 0px;
      text-align: center;
      margin: 0px 11px 0px 11px;

      .total-emission {
        font-size: 18px;
        font-weight: bold;
        line-height: 6px;
        color: #2161ff;
      }

      .emission-level {
        font-size: 18px;
        font-weight: bold;
        line-height: 6px;
        color: #f24242;
      }
    }
  }

  .emission-bottom-view {
    height: 106px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(13, 111, 200, 0.26);
    border-radius: 10px 0px 15px 0px;
    margin: 14px 25px 0px 25px;

    p {
      margin: 0px;
    }

    .emission-bottom-title {
      font-size: 13px;
      color: #333333;
      margin: 0px;
      padding: 15px 0px 0px 15px;
    }

    .emission-bottom-body {
      display: flex;
      justify-content: center;
    }

    .emission-bottom-item {
      width: 150px;
      height: 53px;
      background-repeat: no-repeat;
      background-image: url("../assets/images/transparent_bg.png");
      margin: 9px 15px 15px 17px;
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }

      div {
        margin-left: 10px;
      }

      span {
        margin-left: 2px;
      }

      .convert-result {
        margin-top: 4px;
        font-size: 16px;
        color: #2161ff;
        font-weight: bold;
      }
    }
  }
}

.btn-block {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;

  .btn-last {
    width: 182px;
    height: 41px;
    background-color: #ffffff;
    border-radius: 20px;
    border: solid 1px #2161ff;
    font-size: 18px;
    font-weight: bold;
    color: #2161ff;
    margin-bottom: 10px;
  }

  .btn-share {
    width: 182px;
    height: 41px;
    background-color: #2161ff;
    border-radius: 20px;
    margin-left: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    border: none;
    margin-bottom: 10px;
  }
}
</style>
